import { toast } from 'react-hot-toast';

export const successMessage = (message: string, duration?: number, id?: string) => {
   toast.success(message, { duration: duration || 3000, id: id });
};

export const errorMessage = (message: string, duration?: number, id?: string) => {
   toast.error(message, { duration: duration || 3000, id: id });
};
